import { adviceSubmenus, compareSubmenus, petSubmenus, footerPetInsuranceSubmenus, footerResourcesSubmenus, footerCompanySubmenus } from "@/src/data/menus";

/**
 * Configuration for the Compare Widget content.
 * @type {import("@/src/@types/ContentConfig").IContentConfig}
 */
const contentConfig = {
    compareWidget: [
        {
            id: "hero",
            subheading:
                "Compare pet insurance with ease! See how Spot plans stack up against the competition. Our guide can help you make a confident, well-informed decision about your pet's health care."
        },
        {
            id: "options",
            subheading:
                "Choosing the right pet insurance can come down to comparing key factors: policies, coverage, claims processes, and reimbursement levels. Understanding these details can help ensure you get the best value and protection for your pet."
        },
        {
            id: "columns",
            columns: [
                {
                    id: "column1",
                    heading: "Coverage",
                    subheading:
                        "Our Accident-Only plan can offer financial support when unexpected accidents happen, with a $20,000 annual limit. For broader protection, choose our Accident & Illness plan with annual limit options of $5,000, $10,000, or unlimited."
                },
                {
                    id: "column2",
                    heading: "Wellness Riders",
                    subheading:
                        "Wellness riders are optional add-ons for an additional cost, available exclusively with our Accident & Illness plans. Get reimbursed for routine preventative care services like wellness exams, vaccinations, and microchip implantation."
                },
                {
                    id: "column3",
                    heading: "Additional Benefits",
                    subheading:
                        "Enjoy help with peace of mind with these valuable benefits. Get up to $500 reimbursement per incident for unexpected costs like trip cancellations due to your pet needing urgent, lifesaving care, boarding fees (up to $25/day) if you are hospitalized, and lost pet recovery expenses."
                },
                {
                    id: "column4",
                    heading: "Pre-existing Conditions",
                    subheading:
                        "Pet insurance typically doesn't cover pre-existing conditions – that's pretty standard. With a Spot plan, if your pet shows signs of an illness or injury before their coverage begins, the condition will be considered pre-existing and will not be eligible for coverage."
                }
            ]
        }
    ],
    compareChartDisclaimer:
        "Comparison information provided using publicly available information as of 3/5/24 for the purpose of summarizing program features, not a specific plan. Questions regarding other provider’s plans should be answered by contacting an agent of that company. It is our intention to reflect accurate comparison information. We attempt to keep information up to date but it may change from time to time. If you are aware of any inaccuracies or changes in the information provided, let us know by emailing customercare@spotpetinsurance.ca or by mailing PTZ Insurance Services Ltd. at 710 Dorval Drive, Suite 400, Oakville, ON, L6K 3V7.",
    displaySpotPlanComparison: false,
    displayWeTakeCare: false,
    citationLink: false,
    displayTrustPilot: true,
    displayAccolades: false,
    licensedVet: "Get vet treatment in Canada or the US.",
    claimSubmission: "Send us your bill online, by email, or via fax.",
    displayPlanOptionsCTA: false,
    policyInclusionsModal: [
        {
            heading: "What’s Covered?",
            description:
                "Each type of coverage includes exam fees, diagnostics, and treatment. Our plans cover the most advanced treatments, like chemotherapy and surgery, and some you may not expect, such as stem-cell therapy and acupuncture, so you can follow your vet’s recommendations with less worry about cost."
        },
        {
            heading: "Accidents",
            description:
                "Accident coverage will take care of costs for injuries and emergencies related to accidents, like bite wounds, cuts, broken bones, lodged foreign objects, and toxic ingestions."
        },
        {
            heading: "Illnesses",
            description:
                "With illness coverage, you’ll be reimbursed for the costs of major and minor illnesses, such as cancer, respiratory infections, diabetes, hereditary conditions, and more."
        },
        {
            heading: "Hereditary & Congenital Conditions",
            description:
                "This coverage is for the costs of inherited conditions and birth defects that don’t show symptoms until later in your pet’s life, like heart disease, IVDD, eye disorders, and hip dysplasia."
        },
        {
            heading: "Behavioral Consults/Treatment",
            description:
                "Veterinary consultations to diagnose and treat Your Pet’s abnormal behavior, or for behavioral problems due to an underlying medical condition, are eligible expenses, paid under ‘Alternative Therapies’ portion of Your Policy, when conducted or referred by a licensed Veterinarian by a Certified Animal Behavioral Therapist."
        },
        {
            heading: "Sample policy",
            description: "View our sample policy by ",
            link: { url: "/sample-policy", text: "clicking here" }
        }
    ],
    accidentOnlyInclusions: [
        {
            heading: "What’s Covered?",
            description:
                "Accidents are sudden and unexpected events brought about by an external influence resulting in an acute injury to Your Pet, identifiable and unintended. Examples of common accidents include falling from a balcony, cutting a paw, or being hit by a car."
        },
        {
            heading: "Surgery and Hospitalization",
            description: "This covers the eligible costs of accidents that result in hospitalization or surgery, including foreign body removals, anesthesia, and diagnostics."
        },
        {
            heading: "Medical Supplies",
            description: "The costs of supplies used to treat an accident, including bandages, splints, casts, and cones."
        },
        {
            heading: "Tooth Extractions",
            description: "Accident coverage for tooth extractions includes fractured teeth due to an accident or injury to the mouth."
        },
        {
            heading: "Sample Policy",
            description: "View our sample policy by ",
            link: { url: "/sample-policy", text: "clicking here" }
        }
    ],
    menus: {
        siteHeader: [
            { title: "Pet Insurance", href: undefined, submenu: petSubmenus },
            { title: "Compare", href: undefined, submenu: compareSubmenus },
            { title: "Advice", href: undefined, submenu: adviceSubmenus },
            { title: "Employers", href: "/employers" },
            { title: "Spot Perks", href: "/spot-perks" }
        ],
        siteFooter: [
            { title: "Pet Insurance", links: footerPetInsuranceSubmenus, className: "sm:grid-cols-2" },
            { title: "Resources", links: footerResourcesSubmenus, className: "sm:grid-cols-2" },
            { title: "Company", links: footerCompanySubmenus, className: "sm:grid-cols-2" }
        ]
    },
    lowestPolicyPrice: "28" //https://quote.spotpetinsurance.ca/?quoteId=c2b2edfa-41dc-465b-2b0a-08dd2be15dbc - Quote on 01/03/2025 - Male Cat - Domestic Shorthair Mix - 3 Months Old
};

export default contentConfig;
